import {
    gql
} from "@apollo/client";

export const RETRIEVE_TYPE_PRICES = gql`
    query gqlRetrieveTypePrices {
        data: gqlRetrieveTypePrices {
            nID
            sNameKey
            languages
        }
    }
`;

export const RETRIEVE_TYPE_PRICE_BY_ID = gql`
    query gqlRetrieveTypePriceById($nID: Int!) {
        data: gqlRetrieveTypePriceById(nID: $nID) {
            nID
            sNameKey
            languages
        }
    }
`;